import React, { useState, useEffect } from "react";

export const SearchBar = ({
  filters = {},
  setFilters,
  fields = [],
  onSearch,
  // Optional: (key, value) => called as a field changes, before Search. May return
  // other field values to set too (e.g. clear Branch when Company changes).
  onFieldChange,
}) => {
  const [localValues, setLocalValues] = useState({});

  // Re-initialize when the applied filters or the set of fields change, not on every
  // parent render (`fields` is usually a new array each render, which wiped unsaved picks).
  const fieldsSignature = JSON.stringify(
    fields.map((f) => [f.key, f.defaultValue ?? null]),
  );
  useEffect(() => {
    const initialValues = {};
    fields.forEach((field) => {
      initialValues[field.key] =
        filters[field.key] ??
        field.defaultValue ??
        (field.type === "select" ? "All" : "");
    });
    setLocalValues(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, fieldsSignature]);

  const handleFilterChange = (key, value) => {
    const extra = (onFieldChange && onFieldChange(key, value)) || {};
    setLocalValues((prev) => ({
      ...prev,
      [key]: value,
      ...extra,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Combine existing filters with current local input values
    const combinedValues = {
      ...filters,
      ...localValues,
    };

    if (setFilters) {
      setFilters(combinedValues);
    }

    if (onSearch) {
      onSearch(combinedValues);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="d-flex gap-2 mb-4 align-items-center w-100"
    >
      {fields.map((field) => (
        <div className="col" key={field.key}>
          {field.type === "select" ? (
            <select
              className="status-select w-100"
              title={`Filter by ${field.label}`}
              value={
                localValues[field.key] !== undefined
                  ? localValues[field.key]
                  : (field.defaultValue ?? "All")
              }
              onChange={(e) => handleFilterChange(field.key, e.target.value)}
            >
              {field.options?.map((opt, idx) => {
                const isObject = typeof opt === "object" && opt !== null;
                const optionValue = isObject ? opt.value : opt;
                const optionLabel = isObject ? opt.label : opt;

                return (
                  <option key={idx} value={optionValue}>
                    {optionLabel}
                  </option>
                );
              })}
            </select>
          ) : (
            <input
              type="text"
              className="filter-input w-100"
              title={`Filter by ${field.label}`}
              placeholder={field.placeholder || `Search ${field.label}...`}
              value={localValues[field.key] ?? ""}
              onChange={(e) => handleFilterChange(field.key, e.target.value)}
            />
          )}
        </div>
      ))}

      <div className="col-auto">
        <button
          type="submit"
          className="btn btn-primary px-4 border-0 text-nowrap btn-navy text-nowrap"
        >
          <i className="bi bi-search me-2"></i>Search
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
